import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import { fetchContentfulResults } from '../../features/contentful/actions';
import styles from './index.module.css';
import ModalContentList from './ModalContentList';
import { AnalyticsContext } from '../Analytics/Provider';
import { EVENTS } from '../Analytics/config';

class WhatsNewModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.title = 'What’s New in PagerDuty';
    this.errorMesssage = 'Unable to load content, try again later.';

    this.state = { isOpen: false };
    this.toggleModal = this.toggleModal.bind(this);
    this.onAfterOpen = this.onAfterOpen.bind(this);
  }

  componentDidMount() {
    const root = document.getElementById('root') || document.getElementById('ember-app');
    if (root) { Modal.setAppElement(root); }
  }

  onAfterOpen() {
    this.props.fetchContentful();
    this.context.track(EVENTS.OPEN_WHATS_NEW_MODAL);
  }

  toggleModal() {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  }

  render() {
    const fadeAnimation = this.state.isOpen ? styles.fade_in : styles.fade_out;

    return (
      <React.Fragment>
        <Modal
          closeTimeoutMS={200}
          isOpen={this.state.isOpen}
          onAfterOpen={this.onAfterOpen}
          onRequestClose={this.toggleModal}
          style={{ overlay: {}, content: {} }}
          contentLabel={this.title}
          portalClassName={styles.modal_root}
          overlayClassName={`${styles.modal_backdrop} ${fadeAnimation}`}
          className={`${styles.modal} ${fadeAnimation}`}
          bodyOpenClassName={styles.body_modal_open}
          htmlOpenClassName={styles.html_modal_open}
        >
          <div className={styles.modal_header}>
            <button type="button" onClick={this.toggleModal} className={styles.close}>&times;</button>
            <h3 className={styles.modal_title}>{this.title}</h3>
          </div>
          <div className={styles.modal_body}>
            <div className={styles.modal_content_wrapper}>
              {<ModalContentList items={this.props.items} />}
              {this.props.error
                && (
                <div className={styles.error_message}>
                  {this.errorMesssage}
                </div>
                )}
              <div className={styles.release_notes}>
                For more updates check out our
                {' '}
                <a href="https://support.pagerduty.com/docs/platform-release-notes">release notes</a>
                .
              </div>
            </div>
          </div>
        </Modal>
        {this.props.children({ onClick: this.toggleModal })}
      </React.Fragment>
    );
  }
}
WhatsNewModal.contextType = AnalyticsContext;
WhatsNewModal.defaultProps = {
  error: null
};

WhatsNewModal.propTypes = {
  children: PropTypes.func.isRequired,
  fetchContentful: PropTypes.func.isRequired,
  items: PropTypes.oneOfType([PropTypes.array]).isRequired,
  error: PropTypes.oneOfType([PropTypes.object])
};

const mapStateToProps = state => ({
  items: state.contentful.items,
  error: state.contentful.error
});

const mapActionsToProps = { fetchContentful: fetchContentfulResults };

export default connect(mapStateToProps, mapActionsToProps)(WhatsNewModal);
